module.exports = __webpack_public_path__ + "static/intro-9d79fa202274bc715bbb20767c922a2a.png";